import { lazier } from '@shared/components';

export const Campouts = lazier(() => import('./CampoutsModal'), false);
export {
  default as CampoutsButton,
  CampoutsCreateButton,
} from './CampoutsButton';
export { default as EditCampoutButton } from './EditCampoutButton';
